import { useState } from 'react';

import { recordLinkV2 } from 'utilities/tagging';
import { IA_INVESTMENT_HOME_INTERACTIONS } from 'constants/tagging';

const monthsTags = ['1month', '3months', '6months', '12months'];
const horizon = ['1m', '3m', '6m', '12m'];
const sorting = ['DESC', 'ASC'];

export const useFilters = compact => {
    const [month, setMonth] = useState(2);
    const [order, setOrder] = useState(0);
    const [market, setMarket] = useState({ value: false });
    const [asset, setAsset] = useState();
    const [page, setPage] = useState(0);

    const handleMonth = selectedMonth => {
        setPage(0);
        setMonth(selectedMonth);

        recordLinkV2({
            accionEvento: 'monthSelection',
            categoriaEvento: IA_INVESTMENT_HOME_INTERACTIONS,
            etiquetaEvento: monthsTags[selectedMonth],
        });
    };

    const handleOrder = selectedOrder => {
        setPage(0);
        setOrder(selectedOrder);

        recordLinkV2({
            accionEvento: 'orderingSelection',
            categoriaEvento: IA_INVESTMENT_HOME_INTERACTIONS,
            etiquetaEvento: selectedOrder === 0 ? 'biggestIncrease' : 'biggestDecrease',
        });
    };

    const handleMarket = selectedMarket => {
        setPage(0);
        setMarket(selectedMarket);

        recordLinkV2({
            categoriaEvento: IA_INVESTMENT_HOME_INTERACTIONS,
            accionEvento: 'marketDropdown',
            etiquetaEvento: selectedMarket.label,
        });
    };

    const handleAsset = ({ target: { value } }) => {
        setPage(0);
        setAsset(value);
    };

    const handlePage = page => {
        setPage(page);
    };

    return {
        filtersData: {
            month,
            handleMonth,
            order,
            handleOrder,
            market,
            handleMarket,
            asset,
            handleAsset,
            page,
            handlePage,
        },
        filtersParams: {
            horizon: horizon[month],
            sorting: sorting[order],
            itemsPage: compact ? 5 : 20,
            page,
            ...(market && market.value ? { micCode: market.value } : {}),
            ...(asset && asset.length > 2 ? { asset } : {}),
        },
    };
};
